const getOfferByPropertyId = (packageOffers) => {
  const byPropertyId = {};
  if (packageOffers) {
    packageOffers.forEach((packageOffer) => {
      byPropertyId[packageOffer.propertyId] = packageOffer;
    });
  }

  return byPropertyId;
};

export default getOfferByPropertyId;
